export default "__VITE_ASSET__63763333__"